import React from 'react';
import HeroImage from '../../../assets/images/services/banking-license/hero-image.png'
import PageBanner from '../../../assets/images/services/banking-license/page-banner.png'

import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { GiCheckMark } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../components/Constant/button/Button";

const BreadCrumbsData = [
    { name: 'Offshore Advisory', link: '/' },
    {
        name: 'Banking License – Panama',
        link: '/banking-license-panama',
    },
]

function BankingLicensePanama () {

    return (
        <main className='main'>
            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>

                    <h1 className='section-title'>
                        Banking License – Panama
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                Establish an Offshore or Onshore Bank in Panama
                            </h3>
                            <p className='page-paragraph'>
                                <b>Panama</b> is one of the world’s most respected <b>offshore banking centers</b>. With a <b>strategic location</b>, <b>territorial tax regime</b>, and <b>strict banking secrecy laws</b>, it attracts <b>financial institutions, HNWIs, and multinational groups</b>.
                                <br/>
                                The <b>Superintendence of Banks of Panama (SBP)</b> regulates the sector, offering <b>General Banking Licenses</b> for <b>local and international activity</b>, and <b>International Banking Licenses</b> for <b>offshore-only operations</b>.
                            </p>
                            <PageList
                                items={[
                                    {
                                        title: "Offshore & Private Banks",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Investment & Corporate Banks",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Regional Banking Hubs",
                                        icon: GoDotFill,
                                    },
                                ]}
                            />
                            <Button
                                text="Request a Panama Banking Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <BannerPageImg src={PageBanner} />
                    <b/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Choose Panama for Banking?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Global Financial Hub",
                                    paragraph: "70+ banks from 30+ countries",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strong Regulation",
                                    paragraph: "Supervised by SBP since 1998",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexible Structures",
                                    paragraph: "Offshore-only or full-service banks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Territorial Tax System",
                                    paragraph: "No tax on foreign-sourced income",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strategic Location",
                                    paragraph: "Gateway between North & South America",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Asset Protection",
                                    paragraph: "Strict confidentiality and investor-friendly laws",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Types of Banking Licenses in Panama
                        </h3>
                        <p className='page-subtitle'>1. General Banking License</p>
                        <PageList
                            items={[
                                { paragraph: "Allows banking activities in Panama and abroad.", icon: GoDotFill },
                                { paragraph: "Can accept deposits from Panamanian residents and foreigners.", icon: GoDotFill },
                                { paragraph: "Capital Requirement: USD 10 million minimum.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>2. International Banking License (Offshore Bank)</p>
                        <PageList
                            items={[
                                { paragraph: "Allows banking activities only with non-residents and outside Panama.", icon: GoDotFill },
                                { paragraph: "Cannot take deposits from Panamanian residents.", icon: GoDotFill },
                                { paragraph: "Capital Requirement: USD 3 million minimum.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>Services Covered by a Panama Banking License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Accepting Deposits",
                                    paragraph: "Local & international, depending on license",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Issuing Loans and Credit Facilities",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Private and Corporate Banking",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investment Banking and Wealth Management",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "International Trade Finance",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Custody & Fiduciary Services",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of a Panama Banking License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Prestige & Recognition",
                                    paragraph: "Panama is a trusted offshore banking hub",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Territorial Tax Advantage",
                                    paragraph: "Foreign income exempt from local tax",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Global Market Access",
                                    paragraph: "Link to LatAm, North America, and beyond",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investor Attraction",
                                    paragraph: "Strong perception among HNWIs and institutions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexibility",
                                    paragraph: "Option to operate offshore-only or full-service",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Licensing Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Pre-Application Consultation",
                                    paragraph: "Define banking model (general vs offshore)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company Incorporation",
                                    paragraph: "Establish Panamanian entity",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Application Submission",
                                    paragraph: "Business plan, AML/KYC framework, capital proof",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "SBP Review",
                                    paragraph: "Due diligence on shareholders, directors, and compliance systems",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Approval & Licensing",
                                    paragraph: "Usually 9–12 months",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "9–12 months",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From USD 250,000+ (legal, compliance, advisory)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirement",
                                    paragraph: "USD 10M (General License), USD 3M (International License)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "Audits, SBP supervision, compliance reporting",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Specialists in Offshore Banking Structures",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Full Support",
                                    paragraph: "Incorporation, license filing, compliance, audits",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Introductions to Core Banking Providers, PSPs, and Card Issuers",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Balanced Advice",
                                    paragraph: "Panama vs Western Sahara vs Mwali vs EU jurisdictions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Ongoing Compliance & Reporting Support",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                    </div>

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>
                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />
                    <CTA
                        title="Looking to establish a bank in one of the world’s most recognized offshore centers?"
                        description=
                            "<b>Panama</b> offers <b>General and International Banking Licenses</b>, <b>global prestige</b>, and <b>strong asset protection</b>."
                        buttonText="Book a Panama Banking Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    );
}

export default BankingLicensePanama;

const faqData = [
    {
        question: "What’s the difference between General and International Banking Licenses?",
        content: [
            { type: "answer", text: "General = local + international banking. International = offshore-only (non-residents)." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "USD 3M (International), USD 10M (General)." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "9–12 months on average." },
        ],
    },
    {
        question: "Can Panama banks issue cards and IBANs?",
        content: [
            { type: "answer", text: "Yes — many partner with Visa, Mastercard, SWIFT, and SEPA." },
        ],
    },
    {
        question: "Is Panama banking still confidential?",
        content: [
            { type: "answer", text: "Yes — strong asset protection, though aligned with FATF and OECD transparency." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "We licensed an offshore bank in Panama with Offshore Advisory. The SBP process was demanding, but the prestige was worth it.",
        author: "Michael R.",
        role: "Banking Investor",
    },
    {
        quote:
            "Panama gave us global credibility for our private banking project. Offshore Advisory handled everything from legal structuring to compliance.",
        author: "Sofia L.",
        role: "Private Banker",
    },
];